const menu = [
    {
        name: "首页",
        icon: "icon ion-md-home",
        url: "/home",
        code: "1"
    },

    {
        name: "食谱管理",
        icon: "icon ion-md-beer",
        path: "#",
        code: "6",
        url: "#6",
        children: [
            {
                name: "分类设置",
                icon: "",
                url: "/category-set-list",
                code: "3-1"
            },
            {
                name: "标签库",
                icon: "",
                url: "/tag-list",
                code: "3-2"
            },
            {
                name: "食谱库",
                icon: "",
                url: "/recipe-list",
                code: "3-3"
            },
            {
                name: "离线食谱包",
                icon: "",
                url: "/offline-recipes-list",
                code: "3-4"
            },
            /*  {
                      name: "预览食谱",
                      icon: "",
                      url: "#3-8",
                      code:"3-8",
                      children: [
                          {
                              name: "食谱详情页",
                              icon: "",
                              url: "/offline-recipes-list1",
                              code:"3-8-1",
                          },
                          {
                              name: "食谱执行页",
                              icon: "",
                              url: "/offline-recipes-list1",
                              code:"3-8-1",
                          }
                      ]
                  },*/
            {
                name: "在线食谱",
                icon: "",
                url: "/online-recipe-list",
                code: "3-5"
            },
            // {
            //     name: "付费食谱",
            //     icon: "",
            //     url: "/pay-recipe-list",
            //     code: "3-6"
            // },
            {
                name: "语言设置",
                icon: "",
                url: "/lang-set-edit",
                code: "3-7"
            }
        ]
    },
    {
        name: "APK管理",
        icon: "icon ion-md-filing",
        path: "#",
        code: "2",
        url: "/apk-list",
        children: []
    },
    // {
    //     name: "在线食谱分类",
    //     icon: "icon ion-md-filing",
    //     path: "#",
    //     code: "2",
    //     url: "/online-cate/list",
    //     children: []
    // },
    {
        name: "Banner管理",
        icon: "icon ion-md-filing",
        path: "#",
        code: "2",
        url: "/banner/list",
        children: []
    },
    {
        name: "专题菜谱",
        icon: "icon ion-md-filing",
        path: "#",
        code: "2",
        url: "/group-recipe/list",
        children: []
    },
    {
        name: "设备管理",
        icon: "icon ion-md-settings",
        path: "#",
        code: "3",
        url: "#3",
        children: [
            {
                name: "设备信息",
                icon: "",
                url: "/device-info-list",
                code: "3-1"
            },
            {
                name: "故障汇总",
                icon: "",
                url: "/fault-collect-detail",
                code: "3-2"
            },
            {
                name: "报障记录",
                icon: "",
                url: "/fault-record-list",
                code: "3-2"
            },
            {
                name: "测试设备组",
                icon: "",
                url: "/test-device-list",
                code: "3-3"
            }
        ]
    },
    {
        name: "用户管理",
        icon: "icon ion-md-person",
        path: "#",
        code: "4",
        url: "#4",
        children: [
            {
                name: "普通用户",
                icon: "",
                url: "/user-list",
                code: "4-1"
            },
            // {
            //     name: "付费用户",
            //     icon: "",
            //     url: "/vip-user-list",
            //     code: "4-2"
            // }
        ]
    },
    {
        name: "运营管理",
        icon: "icon ion-md-card",
        path: "#",
        code: "5",
        url: "#5",
        children: [
            {
                name: "配件库",
                icon: "",
                url: "/fitting-list",
                code: "5-0"
            },
            // {
            //     name: "锁屏广告图",
            //     icon: "",
            //     url: "/lock-screen-ads-list",
            //     code: "5-1"
            // },
            // {
            //     name: "热门搜索标签",
            //     icon: "",
            //     url: "/hot-tag-list",
            //     code: "5-2"
            // },
            // {
            //     name: "用户搜索记录",
            //     icon: "",
            //     url: "/user-search-record-list",
            //     code: "5-3"
            // },
            {
                name: "通知",
                icon: "",
                url: "/inform-list",
                code: "5-4"
            }
        ]
    }
];

export default menu;
